import { NumberField, SelectInput, TextField, TextInput } from "react-admin";

import { DataKind, ManualWorkerStatus, Resource } from "../../types";
import { componentUtils } from "../component_utils";
import {
  CustomDateTimeField,
  CustomList,
  CustomReferenceField,
  JsonField,
} from "../custom";

const statusChoices =
  componentUtils.generateCapitalCaseSelectChoicesFromEnum(ManualWorkerStatus);

// "By default, <List> does not refresh the data as soon as the user enters
// data in the filter form. Instead, it waits for half a second of user
// inactivity (via `lodash.debounce`) before calling the dataProvider
// on filter change. This is to prevent repeated calls to the API."
//
// Source: https://marmelab.com/react-admin/List.html#debounce
const manualWorkerFilters = [
  <TextInput label="Name" source="name_like" alwaysOn />,
  <SelectInput
    choices={statusChoices}
    label="Status"
    source="status_eq"
    alwaysOn
  />,
  <TextInput
    label="Creator Admin User"
    source="creator_admin_user_email_like"
    alwaysOn
  />,
];

function ManualWorkerList() {
  return (
    <CustomList
      checkPermissionFor={DataKind.ManualWorker}
      defaultSort={{ field: "created_at", order: "DESC" }}
      displayCreate={true}
      filters={manualWorkerFilters}
    >
      <TextField label="Id" source="id" />
      <TextField label="Name" source="name" />
      <TextField label="Status" source="status" />
      <NumberField label="Failed Attempts Made" source="failed_attempts_made" />
      <CustomReferenceField
        label="Creator Admin User"
        source="creator_admin_user_id"
        reference={Resource.AdminUser}
      >
        <TextField source="email" />
      </CustomReferenceField>
      <JsonField label="Payload" source="payload" sortable={false} />
      <CustomDateTimeField label="Created At" source="created_at" />
      <CustomDateTimeField label="Ended At" source="ended_at" />
      <CustomDateTimeField label="Started At" source="started_at" />
      <CustomDateTimeField label="Updated At" source="updated_at" />
    </CustomList>
  );
}

export default ManualWorkerList;
